import axios from "axios";

export interface ServiceTemporaryApiType {
  update: (data: {
    UserId: string;
    Token: string;
    FirstName: string;
    LastName: string;
  }) => Promise<any>;
}

export const serviceTemporaryApi: ServiceTemporaryApiType = {
  update: (data) => {
    try {
      return axios.post(
        `https://petrosoftbotstelegram20250926001743-hvcdbmcbfjb2hha0.canadacentral-01.azurewebsites.net/_api/auth`,
        data,
      );
    } catch (error) {
      console.error(error);
      return Promise.resolve(null);
    }
  },
};
